<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<p class="mb-4">
					<router-link tag="a" :to="{ name : 'admin.organizations.index'}" class="button icon-button">
						<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
						<span>Back</span>
					</router-link>
				</p>
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mt-2 mb-4 pb-2 pt-2">Edit LHCSA</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-10">
				<form @submit.prevent="onSubmit">
					
					<div class="row">
						<div class="col-12 col-lg-4">
							<div id="step1"  class="highlightable-content active p-3 rounded mb-4">
								<p class="text-uppercase"><strong>1. Description</strong></p>
								<div class="form-group input-content">
									<label>Name</label>
									<input placeholder="Name" type="text" v-model="organization_data.name" class="form-control" v-validate="'required'" name="name">
									<span class="input-error-msg">{{ errors.first('name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Email</label>
									<input placeholder="Email" type="text" v-model="organization_data.email" class="form-control" v-validate="'required'" name="email">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-content">

									<label>Year founded</label>
									<multiselect v-model="organization_data.year_founded" :options="years"></multiselect>

									<label>Year founded</label>
									<datetime v-validate="'required'"  v-model="organization_data.year_founded" hidden-name="year_founded" placeholder="Year founded"></datetime>
									<span class="input-error-msg">{{ errors.first('year_founded') }}</span>

								</div>
								<div class="form-group input-content">
									<label>Became customer on</label>
									
									<datetime v-validate="'required'"  v-model="organization_data.became_costumer" hidden-name="became_costumer" placeholder="Became customer on" ></datetime>
									<span class="input-error-msg">{{ errors.first('became_costumer') }}</span>
								</div>
								<label>Sub atts</label>
								<div class="input-content">
									<v-select class="m-0"  :searchable="false" 
										:selected="10" :options="['Sub att1','Sub att2']">
									</v-select>
								</div>

								<label>Platform Modules</label>
								<div class="input-content">
									<v-select class="m-0" :selected="'Platform 1'" :options="['Platform 1','Platform 2', 'Platform 3']" multiple>
									</v-select>
								</div>
								<div class="form-group input-content">
									<label>Yearly revenue</label>
									<input placeholder="Yearly revenue" type="number" v-model="organization_data.yearly_revenue" class="form-control" v-validate="" name="yearly_revenue">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
							</div><!--highlightable_content-->
							<div class="text-right">
								<button type="submit" class="button large-button">Submit</button>
							</div>
						</div><!--col-->
					</div><!--row-->
				</form>
			</div><!--col-->
		</div><!--row-->
	</div><!--container-->
</template>

<script>
export default {
	data : function(){
		return {
			id : this.$route.params.id,
			organization_data : {
				email : '',
				name : '',
				year_founded : '',
				became_costumer : '',
				colour : '#000000'
			},
			years : []
		}
	},

	created : function(){
		this.getOrganization();

		for(var i = 1900; i<2018;i++){
			this.years.push(i);
		}

	}, 

	methods : {
		getOrganization : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getOrganization', params).then((res) => {
				this.organization_data = res.data.data;

			}).catch((error) => {	
				console.log(error);
			})
		},
		onSubmit : function(){

			this.$validator.validateAll().then((result) => {
				if(result){
					if(typeof(this.organization_data.colour) == 'object')
						this.organization_data.colour = this.organization_data.colour.hex;
					
					this.$store.dispatch('editOrganization', this.organization_data).then((res) => {
						console.log("OK", res);
						this.$router.push({ name : 'admin.organizations.index' });
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/admin/organization/AdminOrganizationEditComponent.vue